import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EditorMenuBar from 'components/atoms/Editors/EditorMenuBar/EditorMenuBar';

const StyledEditorMenu = styled(EditorMenuBar)`
  &.EditorMenu {
    cursor: default;
    font-size: ${props => props.theme.fontSize(16)};
    width: calc(100% - ${props => props.theme.layout(2)});
    left: ${props => props.theme.layout(1)};
    padding: ${props => props.theme.spacing(0.5)};
    position: absolute;
  }
  
  .EditorMenu {
    &-spacer {
      flex-grow: 1;
    }
    &-controls {
      > * {
        pointer-events: all;
      }
    }
  }

  &.EditorMenu-anchor-top {
    top: ${props => props.theme.layout(1)};
    bottom: unset;
    border-top: unset;
    border-bottom: unset;
    border-top-left-radius: ${props => props.theme.radius(1)};
    border-top-right-radius: ${props => props.theme.radius(1)};

    &::after {
      display: block;
      border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
      width: 100%;
      margin-left: 0;
      transform: translateY(${props => props.theme.layout('0.5sp')});
      content: '';
    }
  }
  
  &.EditorMenu-anchor-bottom {
    top: unset;
    bottom: ${props => props.theme.layout(1)};
    border-top: unset;
    border-bottom: unset;
    border-bottom-left-radius: ${props => props.theme.radius(1)};
    border-bottom-right-radius: ${props => props.theme.radius(1)};

    &::before {
      display: block;
      border-top: 1px solid ${props => props.theme.palette.divider};
      width: 100%;
      margin-left: 0;
      transform: translateY(${props => props.theme.layout('-0.5sp')});
      content: '';
    }
  }

  &.EditorMenu-collapsed {
    pointer-events: none !important;
    background-color: transparent;
    
    &::before, &::after {
      border: unset;
    }
    
    .EditorMenu {
      &-controls {
        justify-content: flex-end;
        
        > * {
          &:not(.EditorMenuDivider, .EditorMenu-spacer) {
            pointer-events: all;
          }
        }
      }
    }
  }
  
  &.EditorMenu-size-small {
    .EditorMenu-controls {
      .MuiButtonBase-root {
        svg {
          font-size: ${props => props.theme.fontSize(18)};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledEditorMenu.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenu;
